export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode === 'dark';
  const primary = theme?.palette?.primary?.main;
  const highlightedCardBgDark = '#524962';
  const highlightedCardBgLight = '#F0EEF5';
  return {
    cardWrapper: {
      flexShrink: 0,
      px: '16px',
      py: '8px',
      borderRadius: '4px',
      border: `1px solid ${isDark ? '#F8F7F929' : '#231F2929'}`,
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      backgroundColor: isDark ? '#3A3444' : '#FFFFFF',
    },
    cardWrapperHover: {
      cursor: 'pointer',
      '@media (hover: hover) and (pointer: fine)': {
        '&:hover': {
          backgroundColor: theme?.palette?.action?.hover,
        },
      },
    },
    highlightedCard: {
      cursor: 'pointer',
      backgroundColor: {
        xs: isDark ? highlightedCardBgDark : highlightedCardBgLight,
        md: theme?.palette?.action?.selected,
      },
    },
    disabledIcon: {
      '& .MuiAlert-action': {
        display: 'none',
      },
    },
    cardHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      minHeight: '40px',
    },
    cardDetails: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      gap: '8px',
    },
    headerIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: isDark ? '#FFFFFF8F' : '#00000099',
    },
    menuIcon: {
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
    },
    status: {
      height: '20px',
      width: 'max-content',
      borderRadius: '100px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: '6.5px',
      fontSize: '12px',
      fontWeight: '500',
      color: isDark ? '#000000' : '#ffffff',
    },
    submittedStatus: {
      height: '20px',
      width: 'max-content',
      borderRadius: '100px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: '6.5px',
      fontSize: '12px',
      fontWeight: '500',
      backgroundColor: isDark ? '#81C784' : '#4CAF50',
      color: isDark ? '#000000' : '#ffffff',
    },
    manualStatus: {
      height: '20px',
      width: 'max-content',
      borderRadius: '100px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: '6.5px',
      fontSize: '12px',
      fontWeight: '500',
      backgroundColor: isDark ? '#231F29' : '#F8F7F9',
      color: primary,
      border: `1px solid ${isDark ? '#D0BCFA80' : '#231F2929'}`,
    },
    pastDueDate: {
      height: '20px',
      width: 'max-content',
      borderRadius: '100px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: '6.5px',
      fontSize: '12px',
      fontWeight: '500',
      backgroundColor: isDark ? '#FFA726' : '#EF6C00',
      color: isDark ? '#000000DE' : '#FFFFFF',
    },
    title: {
      order: 1,
      fontSize: '16px',
      fontWeight: '500',
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      lineClamp: '1',
    },
    subtitle: {
      order: 1,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      lineHeight: '20px',
      color: isDark ? '#FFFFFFB2' : '#00000099',
    },
    extensions: {
      order: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      gap: '8px',
      px: '10px',
      py: '4px',
      backgroundColor: isDark ? '#231F29' : '#F8F7F9',
      border: `1px solid ${isDark ? '#D0BCFA80' : '#45218880'}`,
      borderRadius: '24px',
      color: primary,
      fontSize: '13px',
      fontWeight: '500',
      width: 'fit-content',
      maxWidth: '100%',
      boxSizing: 'border-box',
      cursor: 'pointer',
      outline: 'none',
    },
    extensionsIcon: {
      height: '18px',
      width: '18px',
      color: primary,
    },
    endDate: {
      order: 4,
      fontSize: '12px',
      color: isDark ? '#FFFFFFB2' : '#00000099',
    },
    extensionsModal: {
      display: 'flex',
      flexDirection: 'column',
      width: {
        xs: '343px',
        sm: '90%',
        md: '760px',
      },
      maxWidth: {
        xs: '343px',
        sm: '90%',
        md: '760px',
      },
      height: '640px',
      maxHeight: '640px',
      minHeight: {
        xs: '640px',
        md: '640px',
      },
      bgcolor: theme?.palette?.background?.paper,
      borderRadius: '8px',
      boxShadow: isDark
        ? '0px 12px 36px rgba(0, 0, 0, 0.48)'
        : '0px 8px 32px rgba(0, 0, 0, 0.16)',
      boxSizing: 'border-box',
      overflow: 'hidden',
      outline: 'none',
    },
    extensionsModalHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '16px',
      p: '16px',
    },
    extensionsModalTitleWrapper: {
      flex: '1 1 auto',
      minWidth: 0,
      display: 'flex',
      alignItems: 'center',
    },
    extensionsModalTitle: {
      fontSize: '20px',
      fontWeight: 500,
      lineHeight: '160%',
      letterSpacing: '0.15px',
      color: theme?.palette?.text?.primary,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
      wordBreak: 'break-word',
    },
    extensionsModalClose: {
      color: isDark ? '#FFFFFF8F' : theme?.palette?.grey?.[500],
      flexShrink: 0,
      mt: '-0.3rem',
      mr: '-0.5rem',
    },
    extensionsModalContent: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      alignItems: 'flex-start',
      px: '16px',
      pb: '16px',
    },
    extensionRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      height: '56px',
      px: '8px',
      borderTop: `1px solid ${isDark ? '#FFFFFF1A' : '#D9D9DE'}`,
      boxSizing: 'border-box',
    },
    extensionRowFirst: {
      borderTop: 'none',
    },
    extensionRowIcon: {
      color: theme?.palette?.text?.primary,
      flexShrink: 0,
    },
    extensionRowTitleWrapper: {
      flex: '0 1 auto',
      minWidth: 0,
      display: 'flex',
      alignItems: 'center',
    },
    extensionRowText: {
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '150%',
      letterSpacing: '0.15px',
      color: theme?.palette?.text?.secondary,
      fontFamily: theme?.typography?.fontFamily,
      flex: '1 1 auto',
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
      wordBreak: 'break-word',
    },
    extensionRowCount: {
      flexShrink: 0,
      whiteSpace: 'nowrap',
      color: theme?.palette?.text?.secondary,
      fontSize: '16px',
      fontWeight: 500,
    },
    extensionsList: {
      width: {
        xs: '311px',
        sm: '100%',
        md: '732px',
      },
      maxHeight: {
        xs: 'calc(640px - 80px - 32px)',
        md: 'calc(640px - 80px - 32px)',
      },
      maxWidth: '100%',
      minWidth: 0,
      flex: '0 0 auto',
      border: `1px solid ${isDark ? '#FFFFFF1F' : '#D9D9DE'}`,
      borderRadius: '8px',
      overflowY: 'auto',
      backgroundColor: isDark ? '#231F29' : '#F8F7F9',
      boxSizing: 'border-box',
    },
    grade: {
      color: isDark ? '#81C784' : '#2E7D32',
      fontWeight: 500,
    },
  };
};
